import { runPostTypesConfigSync } from '../../postTypes'

const labels = {
    notFoundButtonBack: 'Előző oldal',
    notFoundButtonHome: 'Főoldal',
    notFoundButtonLogin: 'Belépés',
    notFoundButtonSignup: 'Regisztráció',
    acceptCookiesDetailsLabel: 'Részletek',
    acceptCookiesGrantedLabel: 'Elfogadom',
    acceptCookiesDeniedLabel: 'Elutasítom',
    acceptCookiesClose: 'Bezár',
    cookieDetailsSubmitText: 'Mentés',
    cookieDetailsRequiredLabel: 'Kötelező',
    cookieDetailsAnalyticsLabel: 'Analitika',
    cookieDetailsMarketingLabel: 'Marketing',
    selectAnOperationLabel: 'Művelet kiválasztása',
    searchLabel: 'Keresés',
    themeControlsMode: 'Szín séma',
    themeControlsDarkMode: 'Sötét',
    themeControlsLightMode: 'Világos',
    themeControlsAutoMode: 'Alapértelmezett',
    themeControlsAutoModeSec: 'Az eszköz beállítása szerint',
    themeControlsContrast: 'Kontraszt',
    themeControlsHighContrast: 'Kontrasztosabb',
    leaveWarningCancel: 'Mégsem',
    leaveWarningSubmit: 'Mehet',
    mobileMenu: 'Menü',
    logoAreaLabel: 'Főoldal',
    newReleaseCancelText: 'Folytatom',
    newReleaseSubmitText: 'Újratöltés',
    christmasWishShort: 'Kellemes ünnepeket kívánunk!',
    allLabel: 'Összes',
    pdfViewerThumbnails: 'Oldalképek',
    pdfViewerZoomOut: 'Kicsinyítés',
    pdfViewerZoomIn: 'Nagyítás',
    pdfViewerFitWidth: 'Szélességhez igazítás',
    pdfViewerPan: 'Kézi mozgatás',
    pdfViewerPanActive: 'Kézi mozgatás (bekapcsolva)',
    pdfViewerMore: 'Továbbiak',
    pdfViewerSearch: 'Keresés',
    pdfViewerSearchPlaceholder: 'Keresés a dokumentumban…',
    pdfViewerSearchPrev: 'Előző találat',
    pdfViewerSearchNext: 'Következő találat',
    pdfViewerNoResults: 'nincs találat',
    pdfViewerDownload: 'Letöltés',
    pdfViewerPrint: 'Nyomtatás',
    pdfViewerFullscreen: 'Teljes képernyő',
    pdfViewerFullscreenExit: 'Kilépés a teljes képernyőből',
    pdfViewerClose: 'Bezárás',
    pdfViewerLoading: 'PDF betöltése…',
    pdfViewerError: 'A PDF nem jeleníthető meg.',
    ...runPostTypesConfigSync({ action: 'getConstants', rKey: 'labels' }).reduce((a, v) => {
        return { ...a, ...v }
    }, {})
}

export default labels
